import { Component, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from '../confirm/confirm.component';
import { ChangePasswordDataService } from './shared/change-password.data.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [ChangePasswordDataService]
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  // Para mostrar información de debug.
  debug: boolean = environment.showDebugHelpers;
  // Formulario cambio de contraseña
  formChangePassword: FormGroup = new FormGroup({
    txtCurrentPassword: new FormControl(null, [Validators.required]),
    //Se agrega la validacion de mayúsculas, minúsculas y número en validators.pattern
    txtPassword: new FormControl(null,
                                     Validators.compose([
                                      Validators.minLength(6),
                                      Validators.maxLength(15),
                                      Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
                                      Validators.required,
                                     ]),
    ),     
    txtRedPassword: new FormControl(null, [Validators.minLength(6), Validators.maxLength(15), Validators.required]),
  });
  
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Emite el evento de guardar
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private toastr: ToastrService,
    private cpds: ChangePasswordDataService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Valida las contraseñas del formulario de cambio de contraseña que coincidan
   * para abrir la modal de confirmaciones
   *
   * @memberof ChangePasswordComponent
   */
  validChangePassword() {
    let valid = true;
    if (this.formChangePassword.valid) {
      if (
        this.formChangePassword.controls['txtPassword'].valid &&
        this.formChangePassword.controls['txtRedPassword'].valid
      ) {
        // tslint:disable-next-line:max-line-length
        if (this.formChangePassword.controls['txtPassword'].value === this.formChangePassword.controls['txtRedPassword'].value) {
          if (
            // tslint:disable-next-line: max-line-length
            this.formChangePassword.controls['txtPassword'].value !== this.formChangePassword.controls['txtCurrentPassword'].value
          ) {
            this.confirmAction.new({
              question: '¿Realmente desea cambiar la contraseña?',
              labelConfirm: 'Sí',
              labelDecline: 'No'
            }).then(res => {
              if (res) {
                this.changePassword();
              }
            });
          } else {
            this.toastr.warning(
              'La contraseña nueva debe ser diferente a la contraseña actual, verifica e intentalo de nuevo'
            );
          }
        } else {
          valid = false;
        }
      } else {
        valid = false;
      }

      if (!valid) {
        this.toastr.warning('Las contraseñas no coinciden, verifica e intentalo de nuevo');
      }
    } else {
      // tslint:disable-next-line:max-line-length
      this.toastr.warning('El formulario no es valido, verifiquelo y vuelva a intentarlo', 'Formulario incompleto');
    }
  }

  /**
   * Realiza el cambio de contraseña del usuario
   *
   * @memberof ChangePasswordComponent
   */
  changePassword() {
    if (this.formChangePassword.valid) {
      this.formChangePassword.disable();
      this.cpds.changePassword(
        this.formChangePassword.controls['txtCurrentPassword'].value,
        this.formChangePassword.controls['txtPassword'].value
      ).subscribe(res => {
        if (res) {
          this.closeChangePassword();
        } else {
          this.formChangePassword.enable();
        }
      }, _err => this.formChangePassword.enable());
    }
  }

  /**
   * Cierra el componente de cambio de contraseña
   *
   * @memberof ChangePasswordComponent
   */
  closeChangePassword() {
    this.formChangePassword.reset();
    this.close.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/change-password/change-password.component.ts